import React from 'react'
import { Links } from '../../settings/links'

export const MODERATOR_ROLE = 1

export type MenuItemConfig = {
  translationKey: string
  href: string
  isExternal?: boolean
  requiresModerator?: boolean
  isHiddenOnMedium?: boolean
  requiresAuth?: boolean
}

export type MenuLinkItem = {
  translationKey: string
  to: string
  isExternal?: boolean
  onClick?: (e: React.MouseEvent) => void
}

export type MenuItemWithLabel = MenuItemConfig & { label: string }
export type MenuLinkItemWithLabel = MenuLinkItem & { label: string }

export const useMenuItems = (
  t: (key: string) => string,
  user: { role: number; userId: string | number | null },
  authRedirectHandle: (
    e: React.MouseEvent,
    path: string,
    redirectPath: string
  ) => void
) => {
  const mainMenuItems: MenuLinkItem[] = [
    {
      translationKey: 'header.menu.donate',
      to: '/donate',
      onClick: (e) => authRedirectHandle(e, '/donate', '/donate'),
    },
    {
      translationKey: 'header.menu.search',
      to: '/search',
      isExternal: false
    },
    {
      translationKey: 'header.menu.about',
      to: '/about',
      isExternal: false,
    },
    {
      translationKey: 'header.menu.help',
      to: Links.help,
      isExternal: true,
    },
  ]

  const expandableMenuItems: MenuItemConfig[] = [
    {
      translationKey: 'header.menu.forNonprofits',
      href: Links.charities,
      isExternal: true,
      isHiddenOnMedium: true,
    },
    {
      translationKey: 'header.menu.termsForServices',
      href: Links.terms,
      isExternal: true,
      isHiddenOnMedium: true,
    },
    {
      translationKey: 'header.menu.nonprofitCatalog',
      href: '/nonprofit-catalog',
      isExternal: false,
      isHiddenOnMedium: true,
    },
    {
      translationKey: 'header.menu.moderatorView',
      href: '/moderation',
      isExternal: false,
      requiresModerator: true,
      isHiddenOnMedium: true,
    },
  ]

  const visibleMainItems = mainMenuItems
  const visibleExpandableItems = expandableMenuItems.filter(
    (item) => !item.requiresModerator || user.role === MODERATOR_ROLE
  )

  return {
    mainItems: visibleMainItems.map((item) => ({
      ...item,
      label: t(item.translationKey),
    })) as MenuLinkItemWithLabel[],
    expandableItems: visibleExpandableItems.map((item) => ({
      ...item,
      label: t(item.translationKey),
    })) as MenuItemWithLabel[],
  }
}
